// App.js
import React from 'react';
import { Box } from "@mui/material";
import CustomerForm from './widgets/CustomerForm';




export default function AddCustomerScreen() {



    return (
        <Box sx={{ display: 'flex' }}>
            <Box width={"100%"}>
                <CustomerForm formType={"new"}>

                </CustomerForm>
            </Box>
        </Box>


    )
}